function quickQuotationOverviewModule () {

    this.selector = null,

    this.target = null,

    this.quotation_visible = null,

    this.init = function (selector, target) {

        var _this = this;
        this.selector = selector;
        this.target = target;

        if ($(this.selector).length) {
            _this.checkIfWeShouldShowOrHide();
            $(window).scroll(function() {
                _this.checkIfWeShouldShowOrHide();
            });
        }
    },

    this.checkIfWeShouldShowOrHide = function () {
        var top_of_element = $(this.selector).offset().top;
        var bottom_of_element = $(this.selector).offset().top + $(this.selector).outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
            if (this.quotation_visible == null || this.quotation_visible == true) {
                this.hideQuotationBlock();
            }
        } else {
            if (this.quotation_visible == null || this.quotation_visible == false) {
                this.showQuotationBlock();
            }
        }
    },

    this.hideQuotationBlock = function () {
        this.quotation_visible = false;
        $(this.target).fadeOut();
    },

    this.showQuotationBlock = function () {
        this.quotation_visible = true;
        $(this.target).fadeIn();
    }
}

module.exports = quickQuotationOverviewModule;
